export const isImageOrientationAutoManaged = () => {
    return isChrome81OrHigher()
}

export const isChrome81OrHigher = (): boolean => {
    const userAgentChromeProperty: string[] = navigator.userAgent
        .split(' ')
        .filter(
            str => str.includes("Chrome") || str.includes("Chromium")
        )

    if (userAgentChromeProperty && userAgentChromeProperty.length > 0) {
        const [browser, version] = userAgentChromeProperty[0].split('/')
        const nbVersion = Number.parseFloat(version)
        return nbVersion >= 81
    }
    return false;
}

